import * as React from "react";
import { Context } from "../Context";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
library.add(faSpinner);

export function Loader() {
  const context: any = React.useContext(Context);
  if (context.loaded) {
    return null;
  }
  return (
    <div className="loader">
      <FontAwesomeIcon icon={faSpinner} spin={true} />
      <span>Loading...</span>
    </div>
  );
}
